<div class="iframe-container">
  <p class="chat-header">
    Ask RAMsys
  </p>

  <ng-container *ngIf="iframeUrl; else configError">
    <iframe #iframeElement frameBorder="0" [src]="iframeUrl | safe"
      allow="microphone; clipboard-read; clipboard-write"
      sandbox="allow-scripts allow-same-origin allow-popups allow-modals allow-forms allow-downloads"></iframe>
  </ng-container>

  <ng-template #configError>
    <div class="config-error">
      {{ errorMessage || "Unable to load Ask RAMsys. Please try again later." }}
    </div>
  </ng-template>

</div>